import TyreCloseup from './Tyre_Closeup.jpg';
import TyreDistance from './Tyre_Distance.jpg';

const Images = {
    TyreCloseup,
    TyreDistance
};

export default Images;
